import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authToken: any = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails') || '') : ''; // Example of getting token from localStorage

console.log(req)
  ///api/auth/local
  const authReq = authToken
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken.token ? authToken.token : authToken}` // Add the token to the Authorization header
        }
      })
    : req; // If no token, use the original request

  // Pass the cloned request (or original request) to the next handler
  return next(authReq);
};
